import { useState } from 'react';

import { Box, Flex } from '@chakra-ui/react';
import { Calendar } from '@mesh.ai/rabbit';
import { LabelFieldWrapper } from 'screens/admin/Reviews/ReviewProcessV2Intent/components/LabelFieldWrapper';
import { SectionWrapper } from 'screens/admin/Reviews/ReviewProcessV2Intent/components/SectionWrapper';

import { SettingsV1 } from 'assets/assetsV1/iconComponents';

import { Button } from 'uiToolkitV1/Button';
import { DatePicker } from 'uiToolkitV1/DatePicker';
import { TextLabel } from 'uiToolkitV1/Typography';

import { CompensationTimelineBottomDrawer } from './CompensationTimelineBottomDrawer';

const DiamondIcon = () => <Box w="10px" h="10px" bg="icon.g3" borderRadius="2px" transform="rotate(45deg)" />;

const CircleIcon = () => <Box w="12px" h="12px" borderRadius="50%" bg="icon.g3" />;

const TimelineNode = ({ isFirstOrLast = false }) => {
  const IconComponent = isFirstOrLast ? DiamondIcon : CircleIcon;
  return (
    <Box w="16px" h="16px" display="flex" alignItems="center" justifyContent="center" zIndex={1}>
      <IconComponent />
    </Box>
  );
};

const ConnectingLine = () => <Box flexGrow={1} h="2px" bg="border.CFD7DF" ml="-8px" mr="-8px" />;

const CompensationTimeline = ({ setIsDrawerOpen }) => {
  const timelineData = [
    {
      id: 'launch',
      title: 'Launch',
      description: 'Jan 1, 2025',
      isFirstOrLast: true,
    },
    {
      id: 'proposal',
      title: 'Proposal due by',
      description: 'Feb 10, 2025',
      isFirstOrLast: false,
    },
    {
      id: 'approval',
      title: 'Approval due by',
      description: 'Mar 26, 2025',
      isFirstOrLast: false,
    },
    {
      id: 'publish',
      title: 'Publish due by',
      description: 'Apr 20, 2025',
      isFirstOrLast: true,
    },
  ];

  return (
    <Box p="4px 12px">
      <Box display="flex" width="100%" position="relative">
        {timelineData.map((milestone, index) => (
          <Box key={milestone.id} display="flex" flexDir="column" flexGrow={1} minW="120px" position="relative">
            {/* Timeline nodes and connecting lines */}
            <Box display="flex" alignItems="center" mb="12px">
              <TimelineNode isFirstOrLast={milestone.isFirstOrLast} />
              {index < timelineData.length - 1 && <ConnectingLine />}
            </Box>

            {/* Milestone content */}
            <Flex flexDir="column" gap="10px">
              <TextLabel color="text.g2" fontSize="14px">
                {milestone.title}
              </TextLabel>
              <Flex
                alignItems="center"
                w="fit-content"
                py="10px"
                borderBottom="1px dashed"
                borderColor="neutral.999999"
                cursor="pointer"
                onClick={() => setIsDrawerOpen(true)}
              >
                <TextLabel fontSize="14px">{milestone.description}</TextLabel>
              </Flex>
            </Flex>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export const CompensationTimelineSection = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  return (
    <SectionWrapper
      title="Timelines & reminders"
      subTitle="Specifies key deadlines for the compensation cycle and schedules for automated reminders."
      rightComp={
        <Button variant="outlined" StartIcon={SettingsV1} height="32px" onClick={() => {}}>
          Configure
        </Button>
      }
    >
      <CompensationTimeline setIsDrawerOpen={setIsDrawerOpen} />
      <LabelFieldWrapper label="Effective payroll date" gridTemplateColumns="320px 1fr" gridGap={0} mt="12px">
        <DatePicker
          selectedDate={new Date()}
          onChange={() => {}}
          customInputProps={{
            width: '400px',
            justifyContent: 'space-between !important',
            StartIcon: null,
            EndIcon: Calendar,
          }}
        />
      </LabelFieldWrapper>
      <CompensationTimelineBottomDrawer isOpen={isDrawerOpen} onClose={() => setIsDrawerOpen(false)} />
    </SectionWrapper>
  );
};
